import { render, staticRenderFns } from "./localisation-map.vue?vue&type=template&id=262b83a0&"
import script from "./localisation-map.vue?vue&type=script&lang=ts&"
export * from "./localisation-map.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports